import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  CancelEnrollment401,
  CancelEnrollment403,
  CancelEnrollment404,
  CancelEnrollment500,
  EnrollCourse201,
  EnrollCourse400,
  EnrollCourse401,
  EnrollCourse404,
  EnrollCourse409,
  EnrollCourse500,
  UpdateEnrollmentProgress200,
  UpdateEnrollmentProgress400,
  UpdateEnrollmentProgress401,
  UpdateEnrollmentProgress404,
  UpdateEnrollmentProgressBody
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * 사용자가 특정 강좌에 수강 신청합니다.
 * @summary 수강 신청
 */
export const enrollCourse = (
    courseId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EnrollCourse201>> => {
    
    return axios.post(
      `https://api.ugot.uk/api/courses/${courseId}/enrollments`,undefined,options
    );
  }



export const getEnrollCourseMutationOptions = <TError = AxiosError<EnrollCourse400 | EnrollCourse401 | EnrollCourse404 | EnrollCourse409 | EnrollCourse500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollCourse>>, TError,{courseId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof enrollCourse>>, TError,{courseId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enrollCourse>>, {courseId: string}> = (props) => {
          const {courseId} = props ?? {};

          return  enrollCourse(courseId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EnrollCourseMutationResult = NonNullable<Awaited<ReturnType<typeof enrollCourse>>>
    
    export type EnrollCourseMutationError = AxiosError<EnrollCourse400 | EnrollCourse401 | EnrollCourse404 | EnrollCourse409 | EnrollCourse500>

    /**
 * @summary 수강 신청
 */
export const useEnrollCourse = <TError = AxiosError<EnrollCourse400 | EnrollCourse401 | EnrollCourse404 | EnrollCourse409 | EnrollCourse500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollCourse>>, TError,{courseId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof enrollCourse>>,
        TError,
        {courseId: string},
        TContext
      > => {

      const mutationOptions = getEnrollCourseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정 수강 항목의 학습 진도를 업데이트합니다.
 * @summary 학습 진도 업데이트
 */
export const updateEnrollmentProgress = (
    enrollmentId: string,
    updateEnrollmentProgressBody: UpdateEnrollmentProgressBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateEnrollmentProgress200>> => {
    
    return axios.put(
      `https://api.ugot.uk/api/enrollments/${enrollmentId}/progress`,
      updateEnrollmentProgressBody,options
    );
  }



export const getUpdateEnrollmentProgressMutationOptions = <TError = AxiosError<UpdateEnrollmentProgress400 | UpdateEnrollmentProgress401 | UpdateEnrollmentProgress404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEnrollmentProgress>>, TError,{enrollmentId: string;data: UpdateEnrollmentProgressBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEnrollmentProgress>>, TError,{enrollmentId: string;data: UpdateEnrollmentProgressBody}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEnrollmentProgress>>, {enrollmentId: string;data: UpdateEnrollmentProgressBody}> = (props) => {
          const {enrollmentId,data} = props ?? {};

          return  updateEnrollmentProgress(enrollmentId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEnrollmentProgressMutationResult = NonNullable<Awaited<ReturnType<typeof updateEnrollmentProgress>>>
    export type UpdateEnrollmentProgressMutationBody = UpdateEnrollmentProgressBody
    export type UpdateEnrollmentProgressMutationError = AxiosError<UpdateEnrollmentProgress400 | UpdateEnrollmentProgress401 | UpdateEnrollmentProgress404>

    /**
 * @summary 학습 진도 업데이트
 */
export const useUpdateEnrollmentProgress = <TError = AxiosError<UpdateEnrollmentProgress400 | UpdateEnrollmentProgress401 | UpdateEnrollmentProgress404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEnrollmentProgress>>, TError,{enrollmentId: string;data: UpdateEnrollmentProgressBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEnrollmentProgress>>,
        TError,
        {enrollmentId: string;data: UpdateEnrollmentProgressBody},
        TContext
      > => {

      const mutationOptions = getUpdateEnrollmentProgressMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 사용자가 자신의 수강 신청을 취소합니다. 이 작업을 수행하려면 사용자는 인증되어야 하며, 해당 수강 신청의 소유자여야 합니다.
 * @summary 수강 신청 취소
 */
export const cancelEnrollment = (
    enrollmentId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `https://api.ugot.uk/api/enrollments/${enrollmentId}`,options
    );
  }



export const getCancelEnrollmentMutationOptions = <TError = AxiosError<CancelEnrollment401 | CancelEnrollment403 | CancelEnrollment404 | CancelEnrollment500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{enrollmentId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{enrollmentId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelEnrollment>>, {enrollmentId: string}> = (props) => {
          const {enrollmentId} = props ?? {};

          return  cancelEnrollment(enrollmentId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof cancelEnrollment>>>
    
    export type CancelEnrollmentMutationError = AxiosError<CancelEnrollment401 | CancelEnrollment403 | CancelEnrollment404 | CancelEnrollment500>

    /**
 * @summary 수강 신청 취소
 */
export const useCancelEnrollment = <TError = AxiosError<CancelEnrollment401 | CancelEnrollment403 | CancelEnrollment404 | CancelEnrollment500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{enrollmentId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof cancelEnrollment>>,
        TError,
        {enrollmentId: string},
        TContext
      > => {

      const mutationOptions = getCancelEnrollmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    